module.exports = __webpack_public_path__ + "static/img/zp-logo.1ca25c9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zp-logo.gif
// module id = eI0J
// module chunks = 90